import assetPath from '/app/packages/entity-pages/entity-pages-shared/components/page-error/src/assets/500.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')